import React, { useState, useEffect, useCallback } from 'react';

const Timer = ({ initialTime, onTimeUpdate, isRunning }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);

  // Memoize onTimeUpdate
  const memoizedOnTimeUpdate = useCallback(
    (newTime) => {
      onTimeUpdate(newTime);
    },
    [onTimeUpdate]
  );

  useEffect(() => {
    // Sync internal timeLeft with initialTime when it changes
    setTimeLeft(initialTime);

    if (!isRunning || initialTime <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 0) {
          clearInterval(timer);
          memoizedOnTimeUpdate(0);
          return 0;
        }
        const newTime = prev - 1;
        memoizedOnTimeUpdate(newTime);
        return newTime;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [initialTime, isRunning, memoizedOnTimeUpdate]);

  // Don't render anything; let parent handle display
  return null;
};

export default Timer;